<template>
  <footer class="k-footer">
    <div class="k-footer__content">
      <p class="k-footer__copyright">
        &copy; {{ year }} Kemaris. Alle Rechte vorbehalten.
      </p>
      <div class="k-footer__links">
        <a href="#" class="k-footer__link">Datenschutz</a>
        <a href="#" class="k-footer__link">Impressum</a>
        <a href="#" class="k-footer__link">Hilfe</a>
      </div>
    </div>
  </footer>
</template>

<script>
/**
 * ContentFooter - Modern footer component
 * @description Simple footer with copyright and links
 */
export default {
  name: "ContentFooter",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
